module.exports = __webpack_public_path__ + "static/media/ic_document_location.7b08991d.svg";